<template>
	<div id="searchDriver">
		<section class="content-header">
			<div class="container-fluid">
				<div class="row mb-2">
					<div class="col-md-6 col-12">
						<h1>{{ $t("label.telegram")}}</h1>
					</div>
					<div class="col-md-6">
						<ol class="breadcrumb float-sm-right">
							<li class="breadcrumb-item"><router-link to="/">{{ $t("label.home")}}</router-link></li>
							<li class="breadcrumb-item active">{{ $t("label.telegram")}}</li>
						</ol>
					</div>
				</div>
			</div>
		</section>

		<div class="content">
			<div class="container-fluid">
        <div class="row">
					<div class="col-md-12">
						<div class="card card-info card-outline">
							<div class="card-header">
								<h3 class="card-title">{{ $t('label.subscribe') }} / {{ $t("label.unsubscribe")}}</h3>
							</div>
							<div class="card-body">

                <!-- Main Card -->
                <div class="subscription-card">
                  <div class="card-body-custom">
                    <!-- Icon -->
                    <div class="icon-circle">
                      <fa :icon="isSubscribed ? fas.faBell : fas.faBellSlash" size="3x" class="text-white"/>
                    </div>

                    <!-- Status Badge -->
                    <div class="text-center mb-4">
                    <span class="status-badge" :class="{ 'subscribed': isSubscribed }">
                        <span class="status-dot"></span>
                        {{ isSubscribed ? 'Subscribed' : 'Not Subscribed' }}
                    </span>
                    </div>

                    <!-- Info Box -->
                    <div class="info-box">
                      <p>
                        {{ infoMessage }}
                      </p>
                    </div>

                    <!-- Action Button -->
                    <div class="row">
                      <div class="col-6">
                        <a
                            :href="subscribe_url"
                            target="_blank"
                            class="btn btn-block btn-subscribe btn-primary-custom"
                            :class="isSubscribed ? 'disabled' : ''"
                        >
                          {{ 'Open Telegram' }}
                          <fa :icon="fas.faExternalLinkAlt" class="text-white ml-2"/>
                        </a>
                      </div>
                      <div class="col-6">
                        <button
                            @click="toggleSubscription"
                            class="btn btn-block btn-subscribe"
                            :class="isSubscribed ? 'btn-danger-custom' : 'btn-primary'">
                          {{ isSubscribed ? 'Unsubscribe' : 'Subscribe' }}
                          <fa :icon="isSubscribed ? fas.faBellSlash : fas.faBell" class="text-white ml-1"/>
                        </button>
                      </div>
                    </div>

                    <!-- Privacy Info -->
                    <div class="privacy-text">
                      <i class="fas fa-shield-alt"></i>
                      Your privacy is important. We'll never spam you.
                    </div>
                  </div>
                </div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>  
</template>

<script>
import {fas} from "@fortawesome/free-solid-svg-icons";
import {mapState} from "vuex";

export default {
        name: "Telegram",
        data() {
            return {
                baseURI: "",
                data: {},
                subscribe_url: "",
            }
        },
        computed: {
          fas() {
            return fas;
          },
          ...mapState("user", ["user"]),
          isSubscribed(){
            if(this.data && this.data.status){
              return this.data.status === 1;
            }
            return false;
          },
          infoMessage() {
            return this.isSubscribed
                ? 'You are currently receiving notifications from this bot. You can unsubscribe at any time.'
                : 'Subscribe to receive important updates and notifications directly in your Telegram.';
          }
        },
        mounted() {
          this.getSubscribed();
        },
        methods: {
          getSubscribed() {
            let request_url = this.baseURI + "telegram/status";
            GDCE_Client.requestApi("GET", request_url).then(response => {
              if (response.status && response.data) {
                this.data = response.data;
              }
              // Set subscribe URL
              this.subscribe_url = response.subscribe_url;
            }).catch(() => {
              this.$swal({
                title: this.$t("error.something_went_wrong"),
                icon: "error",
                text: "",
              })
            });
          },
          toggleSubscription() {
            this.$swal({
              title: this.$t('message.are_you_sure'),
              text: "",
              icon: "warning",
              buttons: {
                cancel: this.$t('label.close'),
                confirm: this.$t('label.ok'),
              },
            }).then((confirmed) => {
              if(confirmed === true) {
                let request_url = !this.isSubscribed ? this.baseURI + "/telegram/subscribe" : this.baseURI + "/telegram/unsubscribe";
                let formData = new FormData();
                if(this.isSubscribed) {
                  formData.set('t_user_id', this.data.t_user_id)
                }

                this.$store.state.loading.status = true;
                GDCE_Client.requestApi("POST", request_url, formData).then(response => {
                  if (response.status) {
                    let title = !this.isSubscribed ? "Successfully subscribed!" : "Successfully unsubscribed!";
                    this.$swal({
                      title: title,
                      icon: "success",
                      text: "",
                      buttons: {
                        close: this.$t('label.close'),
                      }
                    });
                    this.getSubscribed();
                  }else if(!response.status && response.message){
                    this.$swal({
                      title: "Not unsubscribed!",
                      icon: "warning",
                      text: response.message,
                      buttons: {
                        close: this.$t('label.close'),
                      }
                    })
                  }
                  this.$store.state.loading.status = false;
                }).catch((error) => {
                  if(error.response && error.response.status === 400){
                    this.$swal({
                      title: "Invalid!",
                      icon: "warning",
                      text: "Please subscribe in Telegram again.",
                      buttons: {
                        close: this.$t('label.close'),
                      }
                    })
                  }else{
                    this.$swal({
                      title: this.$t("error.something_went_wrong"),
                      icon: "error",
                      text: "",
                    })
                  }
                });
              }
            });
          }
        }
    }
</script>

<style scoped>
  .card-body-custom {
    padding: 40px;
  }
  .icon-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: linear-gradient(135deg, #2c5f6f 0%, #3d7a8a 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 30px;
    box-shadow: 0 4px 15px rgba(44, 95, 111, 0.3);
  }
  .icon-circle i {
    font-size: 50px;
    color: white;
  }
  .status-badge {
    display: inline-flex;
    align-items: center;
    padding: 10px 20px;
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    background: #6c757d;
    color: white;
  }
  .status-badge.subscribed {
    background: #28a745;
  }
  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 10px;
    background: white;
    animation: pulse 2s infinite;
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
  .info-box {
    background: #f8f9fa;
    border-left: 4px solid #2c5f6f;
    padding: 20px;
    border-radius: 4px;
    margin: 30px 0;
  }
  .info-box p {
    margin: 0;
    color: #6c757d;
    font-size: 15px;
    line-height: 1.6;
  }
  .btn-subscribe {
    padding: 18px;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    transition: all 0.3s ease;
    border: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .btn-subscribe.btn-primary-custom {
    background: linear-gradient(135deg, #2c5f6f 0%, #3d7a8a 100%);
    color: white;
  }
  .btn-subscribe.btn-primary-custom:hover {
    background: linear-gradient(135deg, #23505d 0%, #2c5f6f 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(44, 95, 111, 0.4);
  }
  .btn-subscribe.btn-danger-custom {
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: white;
  }
  .btn-subscribe.btn-danger-custom:hover {
    background: linear-gradient(135deg, #c82333 0%, #bd2130 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
  }
  .btn-subscribe:active {
    transform: translateY(0);
  }
  .privacy-text {
    text-align: center;
    color: #6c757d;
    font-size: 13px;
    margin-top: 20px;
  }
  .privacy-text i {
    margin-right: 5px;
  }
</style>